import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-investor',
  templateUrl: './investor.component.html',
  styleUrls: ['./investor.component.scss'],
})
export class InvestorComponent {
  logoList = [
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/aboutus/sequoia-v2.webp',
      image: 'https://flowaccountcdn.com/new_landing/image/aboutus/sequoia-v2.png',
      imageAlt: 'sequoia logo',
      imageType: 'jpeg',
      imageClassName: 'sequoia',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/aboutus/money-forward.webp',
      image: 'https://flowaccountcdn.com/image/aboutus/money-forward.png',
      imageAlt: 'money-forward logo',
      imageType: 'png',
      imageClassName: 'money-forward',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/aboutus/beacon@2x.webp',
      image: 'https://flowaccountcdn.com/image/aboutus/beacon@2x.png',
      imageAlt: 'beacon logo',
      imageType: 'png',
      imageClassName: 'beacon',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/aboutus/sbi_investor.webp',
      image: 'https://flowaccountcdn.com/image/aboutus/sbi_investor@2x.png',
      imageAlt: 'sbi-investor logo',
      imageType: 'png',
      imageClassName: 'sbi-investor',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/aboutus/ggv.webp',
      image: 'https://flowaccountcdn.com/image/aboutus/ggv@2x.png',
      imageAlt: 'ggv logo',
      imageType: 'png',
      imageClassName: 'ggv',
    },
    {
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/aboutus/500startup.webp',
      image: 'https://flowaccountcdn.com/image/aboutus/500startup@2x.png',
      imageAlt: '500startup logo',
      imageType: 'png',
      imageClassName: '500startup',
    },
  ]
  constructor(public translate: TranslateService) {}

}
